import {ChangeEvent, FC, useMemo} from 'react';

import {StyledTextAreaAutosize} from './inputs.sc';
import InputLabelWrapper from './InputLabelWrapper';
import {ErrorWithParams} from "~src/services/validators";

interface OwnProps {
  minHeight?: number;
  label: string;
  autoExpand?: boolean;
  error?: string|ErrorWithParams;
  defaultValue?: string | string[];
  className?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  type?: string;
  value?: string | number;
  setInput?: ((instance: HTMLTextAreaElement | null) => void);
  onBlur?: () => unknown;
  onFocus?: () => unknown;
  required?: boolean;
  min?: number;
  autoFocus?: boolean;
  labelKey: string;
}

type Props = OwnProps;

const CustomTextArea: FC<Props> = ({
  autoExpand,
  autoFocus,
  className,
  defaultValue,
  error,
  label,
  labelKey,
  minHeight = 120,
  onBlur,
  onChange,
  onFocus,
  required,
  setInput,
  value,
}) => {


  const err = useMemo<undefined|ErrorWithParams>(() => {
    if (!error) {
      return undefined;
    }

    if (typeof error === 'string') {
      return {message: error, params: {}};
    }

    return error;

  }, [error]);

  return (
    <InputLabelWrapper
      insideForm
      valid={!err}
      hasValue={!!defaultValue || !!value}
      error={err?.message}
      errorParams={err?.params}
      label={label}
      labelKey={labelKey}
      isTextArea
    >
      <StyledTextAreaAutosize
        required={required}
        onBlur={onBlur}
        autoFocus={autoFocus}
        className={className}
        data-translation={labelKey}
        value={value}
        aria-invalid={error ? "true": "false"}
        $valid={!error}
        onChange={onChange}
        onFocus={onFocus}
        minRows={(Math.floor(minHeight / 16))}
        $minHeight={minHeight}
        $autoExpand={autoExpand}
        ref={setInput}

      ></StyledTextAreaAutosize>
    </InputLabelWrapper>
  );
};

export default CustomTextArea;
